"use client";

import { componentCls } from "@faire/slate/lib/tracking";
import { PASSWORDINPUT_UNIQUE_ID_PREFIX } from "@faire/slate/private/password-input/consts";
import { PasswordInputBase } from "@faire/slate/private/password-input/PasswordInputBase";
import type { IPasswordInputWebProps } from "@faire/slate/private/password-input/types";
import type { IText } from "@faire/slate/private/shared/types";
import React from "react";

type IProps = {
  /**
   * Whether the text input component is disabled.
   */
  disabled?: boolean;

  /**
   * Controls the error state of the text input component.
   * When error is a string or `<StrictLocalMsg>` or `<ServerSideLocalMsg>`, error content
   * is displayed in the helper text.
   */
  error?: boolean | IText;

  /**
   * The helper text of the text input component.
   */
  helper?: IText;

  /**
   * The label of the text input component.
   */
  label?: string;

  /**
   * Whether to append "(optional)" text to the input label.
   *
   * @default false
   */
  optional?: boolean;

  /**
   * The placeholder of the password input component.
   */
  placeholder?: string;

  /**
   * The tooltip text for the tooltip in the label.
   */
  tooltipText?: IText;

  /**
   * The value of the text input component.
   */
  value?: string;

  // DO NOT ADD any new prop without aligning with Slate team first
} & IPasswordInputWebProps;

/**
 * A Password Input allows users to enter and edit their passwords.
 *
 * {@link https://www.notion.so/faire/Password-Input-2242efb5c25a80d3be4bf85bcced84bc | Slate/PasswordInput}
 */
export const PasswordInput: React.FC<IProps> = (props) => (
  <PasswordInputBase
    {...props}
    idPrefix={PASSWORDINPUT_UNIQUE_ID_PREFIX}
    className={componentCls()}
    data-component-name="Slate/PasswordInput"
  />
);
